import React, { ChangeEvent } from 'react';
import * as app from "../services/AppService";
import { RowItem } from '../models/Core/row-item';
import { InterfaceComponentsProps } from '../models/Core/componentsCore';
interface TextareaProps extends RowItem, Omit<InterfaceComponentsProps, "Icon" |"isTable"> {
    onChange: (text: string,) => void,
    onBlur?:()=>void,
    elmKey?: string,
    model:string,
    rows: number,
    cols?: number,
    hoover?: string,
    isTable?: boolean,
    tableClass?: string,
    placeholder?:string,
    symbol?: string,
    withLabel?: boolean,
    containerClass?: string,
}
function Textarea(props: TextareaProps) {

    function handler(event: ChangeEvent<HTMLTextAreaElement>) {
        const { value } = event.target;
        if (props.onChange && typeof (props.onChange) == "function")
            props.onChange(value);
    }

    let textarea = <textarea rows={props.rows} cols={props.cols}
        id={props.id ? props.id : "txt" + props.label}
        key={props.elmKey}
        data-bs-trigger={props.hoover ? "hover" : ""}
        data-bs-toggle={props.hoover ? "popover" : ""}
        data-bs-content={props.hoover ? props.hoover : ""}
        className={`form-control form-control-sm border rounded  ${props.isTable ? " border-1  text-center " + props.tableClass : props.class}`}
        disabled={props.disabled}
        onChange={handler} value={props.model}
        onBlur={props.onBlur}
        placeholder={app.translate(props.placeholder) + props.symbol}
    />

    return (props.isTable ? textarea :
        <div className="mt-2">
            {props.withLabel && <label className={`${props.labelClass}`}>{app.translate(props.label)}</label>}
            <div className={`input-group border rounded  ${props.containerClass}`}>
                {textarea}
            </div>
        </div>
    );
}
Textarea.defaultProps = {
    class: " border-0 ",
    labelClass: "text-primary-emphasis",
    tableClass: "",
    type: "text",
    placeholder: "",
    containerClass: " ",
    disabled: false,
    elmKey: "input",
    isTable: false,
    symbol: "",
    withLabel: true,
}
export default Textarea;